import { render, staticRenderFns } from "./ProductosCreate.vue?vue&type=template&id=5bc4e456&"
import script from "./ProductosCreate.vue?vue&type=script&lang=js&"
export * from "./ProductosCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports